
import Vue from 'vue';

export default Vue.extend({
  name: 'modal',
  props: {
    config: Object,
    show: Boolean,
    onHide: Function
  },
  computed: {
    isMultiButtons(): boolean {
      return this.config && this.config.button && Array.isArray(this.config.button);
    }
  },
})
